import { useEffect, useState } from 'react';
import { locationService } from '../api/locationService';
import { unwrapLocationList } from '../constants/kenyaLocations';

/**
 * Shared loader for active regions from master_region API.
 * Reuse across LocationSection, report filters, and profiles.
 */
export default function useActiveRegions() {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await locationService.getActiveRegions();
        if (!cancelled) {
          setRegions(unwrapLocationList(response));
        }
      } catch (err) {
        console.error('Error loading active regions:', err);
        if (!cancelled) {
          setRegions([]);
          setError(err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { regions, loading, error };
}
